import React, {useState} from "react";
import {Button, Space} from "antd";
import {DownOutlined} from "@ant-design/icons";
import { Popup  } from 'antd-mobile';
import styles from './styles.module.less';

type TMobileSignupPopup = {
  className?: string;
  onClick:(forMySelf: boolean) => void;
  isOrganizationAdmin:boolean;
}

const MobileSignupPopup:React.FC<TMobileSignupPopup> = ({isOrganizationAdmin,onClick,className}) => {
  const [visible, setVisible] = useState(false);
  return (
    <>
      <Button type="primary" className={className} onClick={() => {
        setVisible(true);
      }}>
        <Space>
          <p>立即报名认证</p>
          <DownOutlined />
        </Space>
      </Button>
      <Popup
        onMaskClick={() => {
          setVisible(false)
        }}
        mask={false}
        visible={visible}
        position="bottom"
        bodyStyle={{bottom: 56,marginLeft: 20,width: 'calc(50% - 28px)'}}
      >
        <div className={styles.mobile_signup_popup_wrapper}>
          <div className={styles.item} onClick={() => {
            setVisible(false);
            onClick(true);
          }}>替自己报名</div>
          {isOrganizationAdmin && (
            <div className={styles.item} onClick={() => {
              setVisible(false);
              onClick(false);
            }}>替他人报名</div>
          )}
        </div>
      </Popup>
    </>
  )
}
export default MobileSignupPopup;
